import jsonpath from 'jsonpath';
export interface JsonNodeType {
  path: (string|number)[];
  value: unknown;
}
export const findValueUsingJsonPath = (data: unknown, path: string): JsonNodeType[] => {
  const jsonNodes = jsonpath.nodes(data, path);
  return jsonNodes;
};
